import Image from 'next/image';
import styled from "styled-components";

const LoginImageWrapper = styled.div`
    .login-image {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
`;

export function AgenturImage() {

  return (
    <LoginImageWrapper>
      <Image
        src="/images/talentpool/register_agentur.jpg"
        objectFit='cover'
        className="login-image"
        alt="Login Cover Image"
        layout='fill'
      />
    </LoginImageWrapper>
  )
}